import React, { useContext, useState } from "react";
import axios from "@src/utils/requests/axiosInstance";
import { OidcProviderButton } from "./OidcProviderButton";
import ErrorBox from "../mobile/ErrorBox";
import { TranslationContext } from "../translation/TranslationContext";
import { logEvent } from "@src/utils/logClient";
import { openSignInWindow } from "./parentOpenGoogleWindow";

interface ParentGoogleContinueButtonProps {
  type: "login" | "signup" | "consented";
}

export const ParentGoogleContinueButton: React.FC<ParentGoogleContinueButtonProps> = ({ type }) => {
  const t = useContext(TranslationContext);
  const [showError, setShowError] = useState(false);

  const handleClick = () => {
    const baseUrl = process.env.GATSBY_HOME_URL || "https://home.classdojo.com";
    axios
      .get(`${baseUrl}/api/parentGoogleLoginUrl`)
      .then((response) => {
        openSignInWindow({ url: response.data.url, entrypoint: type });
      })
      .catch((error) => {
        logEvent({
          eventName: "web.external_page.parent_google.error",
          metadata: {
            error: error.message,
          },
        });
        setShowError(true);
      });
  };

  return (
    <>
      <button onClick={handleClick} style={{ width: "100%" }} type="button">
        <OidcProviderButton provider="google" />
      </button>
      {showError && (
        <ErrorBox>
          {t.translateWithFallback?.({
            str: "components.signup_teacher.oidc_error",
            fallback: "Something went wrong. Please try again.",
          })}
        </ErrorBox>
      )}
    </>
  );
};
